import Modal from "components/atoms/modal";
import { H4, TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onClose: () => void;
  isPossibleEmail: boolean;
}

const ModalCheckId = ({ onClose, isPossibleEmail }: Props) => {
  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <H4 className="mb-3">아이디 중복 확인</H4>
      <TextSm className="text-black-60% mb-5">
        {isPossibleEmail ? "사용할 수 있는 ID 입니다" : "중복되는 ID입니다."}
      </TextSm>
      <Btn.Blue onClick={onClose} size="large" className="w-full">
        닫기
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalCheckId;
